import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  headerRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
  },
  headerText: {
    minWidth: 0,
    flex: 1,
  },
  eyebrow: {
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    fontSize: "0.7rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(0.5),
  },
  title: {
    fontWeight: 600,
    fontSize: "1.05rem",
    lineHeight: 1.3,
    color: theme.palette.text.primary,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    marginTop: theme.spacing(0.5),
    lineHeight: 1.5,
  },
  body: {
    marginTop: theme.spacing(2.5),
  },
}));

const SectionBlock = ({ eyebrow, title, subtitle, action, children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.headerRow}>
        <Box className={classes.headerText}>
          {eyebrow && (
            <Typography className={classes.eyebrow}>{eyebrow}</Typography>
          )}
          {title && (
            <Typography className={classes.title}>{title}</Typography>
          )}
          {subtitle && (
            <Typography className={classes.subtitle}>{subtitle}</Typography>
          )}
        </Box>
        {action && <Box>{action}</Box>}
      </Box>
      {children && <Box className={classes.body}>{children}</Box>}
    </Box>
  );
};

SectionBlock.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
};

export default SectionBlock;
